import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showNotification } from 'actions/notification';
import { useGetChannels, useGetChannelDetail } from 'actions/chatbot';
import EditForm from './edit-form';
import {
  Container,
  LeftPanel,
  RightPanel,
  EmptyState,
  NewButton,
  ListItem,
  ChannelListName,
  ChannelListSubtext,
} from './styled-comps';

function ChannelsTab() {
  const dispatch = useDispatch();
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [isNew, setIsNew] = useState(false);

  const {
    get: getChannels,
    data: channelsData,
    isProcessing: loading,
    error: channelsError,
  } = useGetChannels();

  const {
    get: getChannelDetail,
    data: channelDetailData,
    error: channelDetailError,
  } = useGetChannelDetail();

  const channels = Array.isArray(channelsData) ? channelsData : [];

  const fetchChannels = useCallback(() => {
    getChannels('list');
  }, [getChannels]);

  useEffect(() => {
    fetchChannels();
  }, [fetchChannels]);

  useEffect(() => {
    if (channelsError) {
      dispatch(
        showNotification({
          text: 'Failed to fetch channels',
          duration: 5,
          showCloseIcon: true,
        }),
      );
    }
  }, [channelsError, dispatch]);

  useEffect(() => {
    if (channelDetailError) {
      dispatch(
        showNotification({
          text: 'Failed to fetch channel detail',
          duration: 5,
          showCloseIcon: true,
        }),
      );
    }
  }, [channelDetailError, dispatch]);

  useEffect(() => {
    if (channelDetailData) {
      setSelectedChannel(channelDetailData);
    }
  }, [channelDetailData]);

  const handleSelect = channel => {
    setIsNew(false);
    getChannelDetail(channel.id);
  };

  const handleNew = () => {
    setIsNew(true);
    setSelectedChannel({
      name: '',
      display_name: '',
      bot_key: '',
      user_type: '',
    });
  };

  const handleSaved = () => {
    fetchChannels();
    setIsNew(false);
    setSelectedChannel(null);
  };

  return (
    <Container>
      <LeftPanel>
        <NewButton label="+ New Channel" onClick={handleNew} />
        {loading && !Array.isArray(channels) ? (
          <EmptyState>Loading...</EmptyState>
        ) : loading && channels.length === 0 ? (
          <EmptyState>Loading...</EmptyState>
        ) : (
          (Array.isArray(channels) ? channels : []).map(ch => (
            <ListItem
              key={ch.id}
              $selected={!isNew && selectedChannel && selectedChannel.id === ch.id}
              onClick={() => handleSelect(ch)}
            >
              <ChannelListName>{ch.display_name || ch.name}</ChannelListName>
              {ch.display_name && ch.name && (
                <ChannelListSubtext>{ch.name}</ChannelListSubtext>
              )}
            </ListItem>
          ))
        )}
        {!loading && Array.isArray(channels) && !channels.length && (
          <EmptyState>No channels found</EmptyState>
        )}
      </LeftPanel>
      <RightPanel>
        {selectedChannel ? (
          <EditForm channel={selectedChannel} onSaved={handleSaved} isNew={isNew} />
        ) : (
          <EmptyState>Select a channel from the list</EmptyState>
        )}
      </RightPanel>
    </Container>
  );
}

export default ChannelsTab;
